
    import '/opt/buildhome/repo/docs/spec/conversation-design.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/docs/spec/conversation-design.zh-CN.md?type=demo')
};